<div [gp-stick-between]="{top: 64}" (onResize)="updateDiagramHeight($event)">
  <div class="row-col" style="padding: 1rem .5rem .5rem; background: white;">
    <div class="row-cell v-m">
      <gp-tree-breadcrumbs *ngIf="tree"
                           [items]="tree?.children"
                           [selectedItem]="selectedLeaf"
                           (breadcrumbSelected)="selectTreeLeaf($event)">
      </gp-tree-breadcrumbs>
    </div>
  </div>
</div>
<gp-tree-diagram *ngIf="tree?.children?.length"
                 [selectedTree]="tree"
                 [isReadOnly]="true"
                 [diagramHeight]="diagramHeight"
                 [isDated]="false"
                 [selectedLeaf]="selectedLeaf"
                 (leafChanged)="selectTreeLeaf($event)">
</gp-tree-diagram>

